import { HttpLink } from "@apollo/client"

type HttpLinkConfig = {
  uri?: string
}

export function httpLink({ uri }: HttpLinkConfig) {
  return new HttpLink({
    uri,
    credentials: "include",
  })
}
